import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { LocationSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/location/dtos/requests/LocationSearchRequestDTO'

export class LocationsFiltersFormModel extends FormModel {

    @IsOptional()
    searchString?: string

    @IsOptional()
    samplingCode?: number

    constructor(initialData?: Partial<LocationsFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

    /**
     */
    static formatDto(formStateManager: IFormStateManager<LocationsFiltersFormModel>): LocationSearchRequestDTO {

        if (!formStateManager.getFormValues())
            return {}

        const formValues = formStateManager.getFormValues()!
        return {
            searchString: formValues.searchString,
            samplingCode: formValues.samplingCode
        }
    }

}
